import routerOptions0 from "/app/app/router.options.ts";
import routerOptions1 from "/app/node_modules/.pnpm/nuxt@3.8.0_@parcel+watcher@2.3.0_@types+node@20.8.6_encoding@0.1.13_eslint@8.51.0_optio_3c31da0f0589756405517cbb672a9ae9/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}